import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSliderModule } from '@angular/material/slider';

import { InlineSVGModule } from 'ng-inline-svg';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMaskModule } from 'ngx-mask';
import { QuillModule } from 'ngx-quill';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { CoreModule } from '../core/core.module';

import { DocumentUtility, FormUtility, LayoutUtility } from './utils';
import { TooltipDirective } from './directives';
import { JsonParsePipe, TimePipe } from './pipes';
import {
  ActionNotificationComponent,
  ConfirmationDialogComponent,
  CheckboxComponent,
  ChipComponent,
  DashboardButtonComponent,
  FileInputComponent,
  DateInputComponent,
  HtmlInputComponent,
  InputComponent,
  AutocompleteComponent,
  SpecialInputComponent,
  TableComponent,
  TooltipComponent,
  DocumentViewerComponent,
  DocumentCardButtonComponent,
  ProgressBarComponent,
  SelectComponent,
  SliderComponent,
  ProfileAvatarComponent,
} from './components';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ActionNotificationComponent,
    ConfirmationDialogComponent,
    FileInputComponent,
    DateInputComponent,
    HtmlInputComponent,
    InputComponent,
    CheckboxComponent,
    SelectComponent,
    AutocompleteComponent,
    ChipComponent,
    SpecialInputComponent,
    TableComponent,
    TooltipComponent,
    DashboardButtonComponent,
    DocumentViewerComponent,
    DocumentCardButtonComponent,
    ProgressBarComponent,
    SliderComponent,
    ProfileAvatarComponent,
    TooltipDirective,
    TimePipe,
    JsonParsePipe,
  ],
  entryComponents: [
    ActionNotificationComponent,
    ConfirmationDialogComponent,
    FileInputComponent,
    TooltipComponent,
    DocumentViewerComponent,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatInputModule,
    MatDatepickerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSliderModule,
    InlineSVGModule,
    PdfViewerModule,
    NgxMaskModule,
    QuillModule,
    CoreModule,
    MatTooltipModule,
  ],
  exports: [
    InputComponent,
    CheckboxComponent,
    SelectComponent,
    AutocompleteComponent,
    ChipComponent,
    FileInputComponent,
    DateInputComponent,
    HtmlInputComponent,
    SpecialInputComponent,
    TableComponent,
    DashboardButtonComponent,
    DocumentViewerComponent,
    DocumentCardButtonComponent,
    ProgressBarComponent,
    SliderComponent,
    ProfileAvatarComponent,
    TooltipDirective,
    TimePipe,
    JsonParsePipe,
    TooltipComponent,
  ],
  providers: [FormUtility, LayoutUtility, DocumentUtility],
})
export class SharedModule {}
